import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TopBar } from "@/components/TopBar";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { PageWrapper } from "@/components/PageWrapper";
import HomePage from "@/pages/HomePage";
import WhatArePeptidesPage from "@/pages/WhatArePeptidesPage";
import LearnPeptides from "@/pages/LearnPeptides";
import ReconstitutionPage from "@/pages/ReconstitutionPage";
import PeptideCalculator from "@/components/PeptideCalculator";
import SchedulePlannerPage from "@/pages/SchedulePlannerPage";
import GetStartedPage from "@/pages/GetStartedPage";
import { PageNavigation, PageBreadcrumb } from "@/components/PageNavigation";
import { Beaker } from "lucide-react";

const CalculatorPage = () => {
  const { t } = useTranslation();
  
  return (
    <div className="min-h-screen bg-background">
      {/* Top Breadcrumb Navigation */}
      <PageBreadcrumb currentPath="/calculator" />

      {/* Header */}
      <header className="w-full py-6 md:py-8 px-4 page-slide-up">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-2">
            <div className="p-2 bg-primary rounded-lg">
              <Beaker className="w-6 h-6 text-primary-foreground" />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-foreground">
              {t('calculator.title')}
            </h1>
          </div>
          <p className="text-sm md:text-base text-muted-foreground">
            {t('calculator.subtitle')}
          </p>
        </div>
      </header>

      {/* Main Content */}
      <main className="pb-12">
        <PeptideCalculator />
      </main>

      {/* Page Navigation */}
      <PageNavigation currentPath="/calculator" />
    </div>
  );
};

// App content with page wrapper
const AppContent = () => {
  return (
    <>
      <TopBar />
      <Navigation />
      <main className="flex-1">
        <PageWrapper>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/what-are-peptides" element={<WhatArePeptidesPage />} />
            <Route path="/learn" element={<LearnPeptides />} />
            <Route path="/reconstitution" element={<ReconstitutionPage />} />
            <Route path="/calculator" element={<CalculatorPage />} />
            <Route path="/schedule" element={<SchedulePlannerPage />} />
            <Route path="/get-started" element={<GetStartedPage />} />
          </Routes>
        </PageWrapper>
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App flex flex-col min-h-screen">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
